import { useEffect, useReducer, useRef, useState } from "react";
import { tvFloorReplay, tvFloorLive } from "../../lib/api";

const init = { active: null, last: null, byAgent: {}, candles: {}, cycle: 0 };
const IDLE_HOLD_MS = 45000;

function reduce(s, a) {
  if (a.type === "reset") return { ...init, candles: a.candles || {}, cycle: s.cycle + 1 };
  const e = a.event;
  const list = [...(s.byAgent[e.agent] || []), e].slice(-60);
  const candles = e.payload?.candles?.length ? { ...s.candles, [e.payload.ticker]: e.payload } : s.candles;
  const active = a.quiet ? s.active : e.agent;
  return { ...s, active, last: a.quiet ? s.last : e, byAgent: { ...s.byAgent, [e.agent]: list }, candles };
}

const chartIndex = (events) => Object.fromEntries(events.filter((e) => e.payload?.candles?.length).map((e) => [e.payload.ticker, e.payload]));

function useReplay(dispatch, on, modeRef) {
  useEffect(() => {
    if (!on) return undefined;
    let timers = [], dead = false, loopT;
    const run = (fx) => {
      if (dead || modeRef.current.mode !== "replay") return;
      dispatch({ type: "reset", candles: chartIndex(fx.events) });
      timers = fx.events.map((ev) => setTimeout(() => modeRef.current.mode === "replay" && dispatch({ type: "event", event: ev }), ev.t_ms));
      loopT = setTimeout(() => run(fx), fx.loop_ms || (fx.events.at(-1)?.t_ms || 0) + 3000);
    };
    tvFloorReplay().then(run).catch(() => {});
    return () => { dead = true; timers.forEach(clearTimeout); clearTimeout(loopT); };
  }, [dispatch, on, modeRef]);
}

function useLive(dispatch, setMode, ref) {
  useEffect(() => {
    let dead = false;
    const poll = async () => {
      try {
        const r = await tvFloorLive(ref.current.seq, ref.current.run);
        if (dead) return;
        const st = ref.current;
        if (r.running && (st.mode !== "live" || r.run_id !== st.run)) {
          st.mode = "live"; st.run = r.run_id; st.seq = 0; st.idleAt = 0; st.chief = "";
          setMode("live"); dispatch({ type: "reset" });
        }
        if (st.mode !== "live") return;
        if (r.chief && r.chief.ts !== st.chief) { st.chief = r.chief.ts; dispatch({ type: "event", event: r.chief, quiet: true }); }
        if (r.run_id === st.run) (r.events || []).forEach((ev) => { st.seq = Math.max(st.seq, ev.seq); dispatch({ type: "event", event: ev }); });
        if (!r.running) {
          st.idleAt = st.idleAt || Date.now();
          if (Date.now() - st.idleAt > IDLE_HOLD_MS) { st.mode = "replay"; setMode("replay"); }
        }
      } catch (e) { /* keep current mode */ }
    };
    poll(); const t = setInterval(poll, 2500);
    return () => { dead = true; clearInterval(t); };
  }, [dispatch, setMode, ref]);
}

export function useFloorFeed() {
  const [state, dispatch] = useReducer(reduce, init);
  const [mode, setMode] = useState("replay");
  const ref = useRef({ run: "", seq: 0, mode: "replay", idleAt: 0, chief: "" });
  useLive(dispatch, setMode, ref);
  useReplay(dispatch, mode === "replay", ref);
  return { ...state, mode };
}
